import {
  Button,
  Col,
  Form,
  FormInstance,
  Input,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Table,
  Upload,
} from "antd";
import { UploadFile } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { FormDatePicker } from "../../Components/FormDatePicker";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  HistoryOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  getAssignedTo,
  getRequestDetailsById,
  getTaskHistory,
  getTaskOwnerStatus,
  getTaskRDManagerStatus,
  getTaskSummaryDetails,
  insertUpdateTaskDetails,
  updateTaskDetailByTaskOwner,
} from "../../Helpers/APIEndpoints/Endpoints";
import { API } from "../../Axios/Axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../../AuthStore/AuthStore";
import { RoleEnum } from "../../Enum/RoleEnum";
import { RequestStatusEnum } from "../../Enum/RequestStatusEnum";
import { TaskStatusEnum } from "../../Enum/TaskStatusEnum";
import dayjs from "dayjs";
import { useActionHandler } from "../../Components/ActionHandlerContext";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ApiStatus } from "../../Enum/ApiStatusEnum";
import Loader from "../../Helpers/Loader/Loader";

dayjs.extend(utc);
dayjs.extend(timezone);

const TaskDetailsTab = (props: any) => {
  //const [form] = Form.useForm(props.form);
  const { interfaceActionHandler } = useActionHandler();
  const form = props.form;
  const [formOptions, setFormOptions] = React.useState<any>({});
  const [taskDetailsData, setTaskDetailsData] = React.useState<any>([]);
  const location = useLocation();
  //console.log("location in task details tab =>", location?.state);

  const { commonContextParams } = useAuthStore();
  const [editingKey, setEditingKey] = useState<number | null>(null);
  const navigate = useNavigate();
  const [taskCurrentStatus, setTaskCurrentStatus] = useState<any>(null);
  const [isCurrentTaskExtended, setIsCurrentTaskExtended] =
    useState<any>(false);
  const [currentRDManagerStatus, setCurrentRDManagerStatus] =
    useState<any>(null);
  const [requestStatus, setRequestStatus] = useState<any>();
  const [closureDate, setClosureDate] = useState<any>();
  const MAX_FILES = 5;
  const MAX_FILE_SIZE_MB = 5;
  const MAX_TOTAL_SIZE_MB = 30;
  const allowedExtensions = [
    "pdf",
    "doc",
    "docx",
    "xlsx",
    "xls",
    "msg",
    "eml",
    "ppt",
    "pptx",
    "png",
    "jpg",
    "jpeg",
  ];
  const ALLOWED_TYPES = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/csv",
  ];
  const [ownerFiles, setOwnerFiles] = useState<UploadFile[]>([]);
  const [closureFiles, setClosureFiles] = useState<UploadFile[]>([]);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const formRef = useRef<FormInstance>(null);
  const [deletedOwnerAttachmentIds, setDeletedOwnerAttachmentIds] =
    useState<string>("");
  const [deletedClosureAttachmentIds, setDeletedClosureAttachmentIds] =
    useState<string>("");
  const [isEditing, setIsEditing] = useState(false);
  const [historyData, setHistoryData] = useState<any>([]);
  const [isHistoryIconClicked, setIsHistoryIconClicked] = useState(false);
  const [selectedStatusId, setSelectedStatusId] = useState<any>(null);

  const [loading, setLoading] = useState(false);

  // Assignee search states for lazy loading dropdown
  const [assigneeOptions, setAssigneeOptions] = useState<any[]>([]);
  const [assigneeLoading, setAssigneeLoading] = useState(false);
  const assigneeSearchTimeout = useRef<any>(null);
  const assigneeCache = useRef<Map<string, any[]>>(new Map());
  const assigneeFromTaskSummary = useRef<Map<number, any>>(new Map()); // Cache assignees from task summary

  const canShowForm =
    isEditing ||
    ((commonContextParams.roleId == RoleEnum.RnDManager ||
      commonContextParams.roleId == RoleEnum.RnDHead) &&
      requestStatus == RequestStatusEnum.TaskAssignmentPending);

  const RequestDetailTabFields = [
    {
      fieldName: "Initiator",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "InitiatorDepartment",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "InitiatorUnit",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RequestDate",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Channel",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RequestDescription",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RequestType",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "OtherRequestType",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "BusinessChannel",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "BusinessImpact",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ExpectedRevenue",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "InternalExternal",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "CustomerName",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ContactPerson",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ContactNumber",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "EmailAddress",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "CustomerAccountNumber",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "CountryLocation",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Location",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ProductType",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Product",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ProductDescription",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "SupportingDocuments",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RequestCategory",
      updates: { isFieldDisable: true },
    },
    // {
    //   fieldName: "SupportingDocuments",
    //   updates: { isFieldDisable: true },
    // },
  ];
  const AcknowledgementDetailsTabFields = [
    {
      fieldName: "DecisionRDHead",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RemarksRDHead",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Priority",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ObservationCategory",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "EstimatedResources",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Impact",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "AssignTo",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "TargetClosureDate",
      updates: { isFieldDisable: true },
    },
  ];
  const ClosureDetailsTabFields = [
    {
      fieldName: "HoursSpentforClosure",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Outcome",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "CostSaved",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "TimeUtilized",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ClosureRemarks",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ClosureDetailsSupportingDocuments",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RnDHeadClosureDecisionId",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RnDHeadClosureRemarks",
      updates: { isFieldDisable: true },
    },
  ];

  const tabFieldConfig: Record<string, any[]> = {
    "Request Details": RequestDetailTabFields,
    "Acknowledgement Details": AcknowledgementDetailsTabFields,
    "Closure Details": ClosureDetailsTabFields,
  };

  const handleFieldVisibility = (
    tabNames: string | string[],
    disableFlag: boolean,
  ): Array<{ fieldName: string; updates: any }> => {
    const tabsArray = Array.isArray(tabNames) ? tabNames : [tabNames];

    return tabsArray.flatMap((tabName) => {
      const fields = tabFieldConfig[tabName];
      if (!fields) return [];

      return fields.map((field) => ({
        ...field,
        updates: {
          ...field.updates,
          isFieldDisable: disableFlag,
        },
      }));
    });
  };

  const columns = [
    {
      title: "Task Title",
      dataIndex: "taskTitle",
      key: "taskTitle",
    },
    {
      title: "Task Description",
      dataIndex: "taskDescription",
      key: "taskDescription",
    },
    {
      title: "Assigned To",
      dataIndex: "assignedToId",
      key: "assignedToId",
      render: (value: any, record: any) => {
        // Use the name from record first, then check cache
        if (record?.name) {
          return record.name;
        }
        // Fallback to cache from task summary
        const id = value?.value ?? value;
        return assigneeFromTaskSummary.current.get(id) || "-";
      },
    },
    {
      title: "Task Deadline",
      dataIndex: "taskDeadline",
      key: "taskDeadline",
      render: (value: any) => {
        return value ? dayjs(value)?.format("DD-MM-YYYY") : null;
      },
    },
    {
      title: "Status",
      dataIndex: "taskRDManagerStatus",
      key: "taskRDManagerStatus",
      render: (value: any) => {
        return value ? value : "Pending";
      },
    },
    {
      title: "Hours Spent",
      dataIndex: "hoursSpent",
      key: "hoursSpent",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <>
          {(commonContextParams.roleId == RoleEnum.TaskOwner &&
            record.statusId != TaskStatusEnum.Closed) ||
          ((commonContextParams.roleId == RoleEnum.RnDHead ||
            commonContextParams.roleId == RoleEnum.RnDManager) &&
            record.rdManagerStatusId != TaskStatusEnum.Closed) ? (
            <Button type="link" onClick={() => handleEdit(record)}>
              <EditOutlined />
            </Button>
          ) : (
            <Button type="link" onClick={() => handleEdit(record)}>
              <EyeOutlined />
            </Button>
          )}
          {RequestStatusEnum.TaskAssignmentPending == requestStatus ? (
            <Button type="link" onClick={() => handleDelete(record)}>
              <DeleteOutlined />
            </Button>
          ) : (
            <></>
          )}
          <Button type="link" onClick={() => getHistoryGridData(record)}>
            <HistoryOutlined />
          </Button>
        </>
      ),
    },
  ];

  const withLoader = async (fn: any) => {
    try {
      setLoading(true);
      await fn();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const formatToLocal = (utcDate: string) => {
    return dayjs.utc(utcDate).local().format("DD-MM-YYYY hh:mm A");
  };

  const Historycolumns = [
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (value: string) => formatToLocal(value),
    },
    {
      title: "Role",
      dataIndex: "role",
    },
    {
      title: "Username",
      dataIndex: "username",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      render: (value: string) => value || "-",
    },
    {
      title: "TAT",
      dataIndex: "tat",
    },
  ];

  const getHistoryGridData = async (record: any) => {
    try {
      const obj = {
        TaskDetailId: record?.key,
      };
      const res = await API.post(getTaskHistory, obj);
      console.log("history res ==>", res);

      if (res?.data?.data?.length > 0) {
        setHistoryData(res?.data?.data);
      }

      setIsHistoryIconClicked(true);
    } catch (error) {
      console.error("History API Error:", error);
    }
  };

  const handleHistoryClose = () => {
    setIsHistoryIconClicked(false);
    setHistoryData([]);
  };

  // useEffect(() => {
  //   if (isHistoryIconClicked) {
  //     const getHistoryData = async () => {
  //       let obj ={
  //         TaskDetailId : editingKey ?  editingKey : 0,
  //       }
  //       const res = await API.post(getHistoryData, obj);
  //     };
  //     getHistoryData();
  //   }
  // }, [isHistoryIconClicked]);

  const handleAdd = async () => {
    try {
      const values = await form.validateFields([
        "taskTitle",
        "taskDescription",
        "assignedToId",
        "taskDeadline",
      ]);
      // Find the selected assignee's name from the dropdown options
      let assigneeName = "";
      if (values.assignedToId) {
        const id = values.assignedToId?.value ?? values.assignedToId;
        // Try to get from current dropdown options
        const found = assigneeOptions.find((opt: any) => opt.value === id);
        assigneeName = found ? found.label : "";
      }

      const formattedTask = {
        key: editingKey ?? Date.now(),
        TaskDetailId: editingKey ? values?.taskDetailId : null,
        taskTitle: values.taskTitle,
        taskDescription: values.taskDescription,
        assignedToId: values.assignedToId?.value ?? values.assignedToId,
        name: assigneeName, // <-- add this line
        statusId: values.statusId?.value ?? values.statusId,
        taskDeadline: values.taskDeadline
          ? dayjs(values.taskDeadline).format("YYYY-MM-DD")
          : null,
        remarks: values.remarks,
        hoursSpent: values.hoursSpent,
      };

      if (editingKey) {
        const updatedData = taskDetailsData?.map((item: any) =>
          item.key === editingKey ? formattedTask : item,
        );
        setTaskDetailsData(updatedData);
        setEditingKey(null);
      } else {
        setTaskDetailsData((prev: any) => [...prev, formattedTask]);
      }

      form.resetFields([
        "taskTitle",
        "taskDescription",
        "assignedToId",
        "taskDeadline",
      ]);
    } catch (error) {
      console.log("Validation Failed:", error);
    }
  };

  const handleUpdate = async () => {
    await withLoader(async () => {
      try {
        if (commonContextParams?.roleId == RoleEnum.TaskOwner) {
          await form.validateFields(["statusId", "remarks", "hoursSpent"]);
        } else if (
          (commonContextParams?.roleId == RoleEnum.RnDManager ||
            commonContextParams?.roleId == RoleEnum.RnDHead) &&
          taskCurrentStatus == TaskStatusEnum.Closed
        ) {
          await form.validateFields(["rDManagerStatus", "taskClosureRemarks"]);
        } else if (
          commonContextParams?.roleId == RoleEnum.RnDManager ||
          commonContextParams?.roleId == RoleEnum.RnDHead
        ) {
          console.log("validating fields for RnD manager/ head");
          await form.validateFields(["assignedToId", "taskDeadline"]);
        }

        const values = form.getFieldsValue();
        console.log("values update===>", values, "edit key", editingKey);

        const formattedTask = {
          key: editingKey ?? Date.now(),
          TaskDetailId: editingKey ? values?.taskDetailId : null,
          taskTitle: values.taskTitle,
          taskDescription: values.taskDescription,
          assignedToId: values.assignedToId?.value ?? values.assignedToId,
          statusId: values.statusId?.value ?? values.statusId,
          taskDeadline: values.taskDeadline
            ? dayjs(values.taskDeadline).format("YYYY-MM-DD")
            : null,
          remarks: values.remarks,
          rDManagerStatus:
            values.rDManagerStatus?.value ?? values.rDManagerStatus,
          taskClosureRemarks: values.taskClosureRemarks,
          hoursSpent: values.hoursSpent,
        };

        console.log("formatted task for update =>", formattedTask);
        if (
          formattedTask?.statusId == TaskStatusEnum.Pending &&
          commonContextParams?.roleId == RoleEnum.TaskOwner
        ) {
          message.error("Task cannot be moved back to Pending status.");
          console.error("Task cannot be moved back to Pending status.");
          return;
        }

        const assignTo =
          typeof values?.assignedToId === "object" &&
          values?.assignedToId !== null
            ? values?.assignedToId.value
            : values?.assignedToId;

        const formData = new FormData();

        formData.append("RequestId", location?.state?.RId);
        formData.append("TaskDetailId", editingKey ? String(editingKey) : "0");
        formData.append("TaskTitle", values?.taskTitle);
        formData.append("TaskDescription", values?.taskDescription);
        formData.append("AssignedToId", assignTo);
        formData.append(
          "TaskDeadline",
          values?.taskDeadline
            ? dayjs(values?.taskDeadline).format("YYYY-MM-DD")
            : "",
        );
        formData.append("StatusId", values?.statusId);
        formData.append("Remarks", values?.remarks || "");
        formData.append("RDManagerStatusId", values?.rDManagerStatus || "");
        formData.append(
          "RDManagerClosureRemarks",
          values?.taskClosureRemarks || "",
        );
        formData.append("CreatedBy", commonContextParams?.userId);
        formData.append("RoleId", commonContextParams?.roleId);
        formData.append("HoursSpent", values?.hoursSpent || 0);

        // OWNER FILES
        ownerFiles?.forEach((file) => {
          if (file?.originFileObj) {
            formData.append("OwnerAttachments", file?.originFileObj);
          }
        });

        // CLOSURE FILES
        // closureFiles?.forEach((file) => {
        //   if (file?.originFileObj) {
        //     formData.append("ClosureAttachments", file?.originFileObj);
        //   }
        // });

        formData.append(
          "OwnerAttachmentIds",
          ownerFiles
            ?.filter((f: any) => f?.id)
            ?.map((f: any) => f?.id)
            ?.join(","),
        );

        // formData.append(
        //   "ClosureAttachmentIds",
        //   closureFiles
        //     ?.filter((f: any) => f?.id)
        //     ?.map((f: any) => f?.id)
        //     ?.join(","),
        // );

        const res = await API.post(updateTaskDetailByTaskOwner, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log("updated res by task owner =>", res);

        if (res?.data?.data?.length > 0) {
          message.success("Task updated successfully");
          const updatedData = await fetchTaskSummaryDetails();
          console.table(updatedData);

          // Check if all tasks are closed
          const allClosed = updatedData?.every(
            (task) => task.taskRDManagerStatus === "Closed",
          );

          if (allClosed) {
            // Calculate total hours spent
            const totalHoursSpent = updatedData?.reduce((sum, task) => {
              return sum + (task.hoursSpent ? parseFloat(task.hoursSpent) : 0);
            }, 0);

            console.log("Total hours spent:", totalHoursSpent);

            // Set total hours to closure details form
            form.setFieldsValue({
              hoursSpentforClosure: totalHoursSpent,
            });

            // Set status as closed
            setSelectedStatusId(TaskStatusEnum.Closed);
            //  setIsStatusClosedSelected(true);

            interfaceActionHandler?.SetActiveTab("Closure Details");

            formRef.current?.setFieldVisibility([
              ...handleFieldVisibility("Request Details", true),
              ...handleFieldVisibility("Acknowledgement Details", true),
              ...handleFieldVisibility("Closure Details", false),
            ]);
          }

          setEditingKey(null);
          if (commonContextParams?.roleId == RoleEnum.TaskOwner) {
            form.resetFields([
              "taskTitle",
              "taskDescription",
              "assignedToId",
              "taskDeadline",
              "statusId",
              "remarks",
              "ownerAttachments",
            ]);
          } else if (
            commonContextParams?.roleId == RoleEnum.RnDHead ||
            commonContextParams?.roleId == RoleEnum.RnDManager
          ) {
            form.resetFields([
              "taskTitle",
              "taskDescription",
              "assignedToId",
              "taskDeadline",
              "statusId",
              "remarks",
              "ownerAttachments",
              "rDManagerStatus",
              "taskClosureRemarks",
            ]);
          }
          setOwnerFiles([]);
          setClosureFiles([]);
          setIsEditing(false);
        } else {
          const data = res?.data;

          if (
            data?.status === ApiStatus.OK ||
            data?.status === ApiStatus.Success
          ) {
            //SUCCESS CASE
            message.success(
              data?.message?.trim() || "Task updated successfully",
            );
            //navigate(-1);
            if (
              Number(commonContextParams?.roleId) === Number(RoleEnum.TaskOwner)
            ) {
              navigate("/TaskDashboard");
            } else {
              navigate("/RequestDashboard");
            }
          } else {
            //ERROR CASE
            const errorMessage =
              data?.errorCode === "DB_VALIDATION" ||
              data?.errorCode === "DBVALIDATION"
                ? data?.message?.trim() || "Failed"
                : "Something went wrong!";

            message.error(errorMessage);
          }
        }
      } catch (error) {
        console.log("Validation Failed:", error);
      }
    });
  };

  const handleEdit = (record: any) => {
    console.log("record in edit =>", record);
    setIsEditing(true);
    setEditingKey(record.key);
    setTaskCurrentStatus(record?.statusId);
    setCurrentRDManagerStatus(record?.rdManagerStatusId);
    setIsCurrentTaskExtended(record?.isExtended);
    setSelectedStatusId(record?.statusId);

    // --- Fix: Ensure Assigned To dropdown is set for new (unsaved) tasks ---
    if (record.assignedToId) {
      // If the record has a name (from new/unsaved row), ensure the dropdown option is present
      if (record.name) {
        const option = { label: record.name, value: record.assignedToId };
        setAssigneeOptions([option]);
        assigneeCache.current.set(record.assignedToId.toString(), [option]);
      } else {
        // Fallback to normal fetch for existing tasks
        fetchCurrentAssignedUser(record.assignedToId);
      }
    } else {
      setAssigneeOptions([]);
    }

    form.setFieldsValue({
      taskTitle: record.taskTitle,
      taskDescription: record.taskDescription,
      assignedToId: record.assignedToId
        ? { label: record.name, value: record.assignedToId }
        : undefined,
      taskDeadline: record.taskDeadline ? dayjs(record.taskDeadline) : null,
      statusId: record.statusId,
      remarks: record.remarks,
      rDManagerStatus: record?.rdManagerStatusId,
      taskClosureRemarks: record?.rdManagerClosureRemarks,
      hoursSpent: record?.hoursSpent,
    });

    if (record?.taskOwnerAttachments) {
      const parsed = JSON.parse(record.taskOwnerAttachments);
      const owner = parsed.map((file: any) => ({
        uid: file.id.toString(),
        name: file.name,
        status: "done",
        url: file.path,
        existing: true,
        id: file.id,
      }));
      setOwnerFiles(owner);
    } else {
      setOwnerFiles([]);
    }

    // CLOSURE ATTACHMENTS
    // if (record?.taskClosureAttachments) {
    //   const parsed = JSON.parse(record.taskClosureAttachments);
    //   const closure = parsed.map((file: any) => ({
    //     uid: file.id.toString(),
    //     name: file.name,
    //     status: "done",
    //     url: file.path,
    //     existing: true,
    //     id: file.id,
    //   }));
    //   setClosureFiles(closure);
    // } else {
    //   setClosureFiles([]);
    // }
    setDeletedOwnerAttachmentIds("");
    // setDeletedClosureAttachmentIds("");
  };

  const handleDelete = (record: any) => {
    const updatedData = taskDetailsData.filter(
      (item: any) => item.key !== record.key,
    );
    setTaskDetailsData(updatedData);
  };

  // Debounced search handler for assignee dropdown
  const handleAssigneeSearch = async (searchValue: string) => {
    // Clear previous timeout
    if (assigneeSearchTimeout.current) {
      clearTimeout(assigneeSearchTimeout.current);
    }

    // Require minimum 2 characters for search to avoid loading too many users
    if (!searchValue || searchValue.trim().length < 2) {
      setAssigneeOptions([]);
      setAssigneeLoading(false);
      return;
    }

    // Check cache first
    if (assigneeCache.current.has(searchValue)) {
      setAssigneeOptions(assigneeCache.current.get(searchValue) || []);
      setAssigneeLoading(false);
      return;
    }

    setAssigneeLoading(true);

    // Debounce with 300ms delay
    assigneeSearchTimeout.current = setTimeout(async () => {
      try {
        const res = await API.post(getAssignedTo, {
          SearchTerm: searchValue.trim(), // Pass search term
        });

        if (res?.data?.data?.length > 0) {
          const options = res.data.data.map((item: any) => ({
            label: item?.name,
            value: item?.Id,
          }));

          // Cache the result
          assigneeCache.current.set(searchValue, options);
          setAssigneeOptions(options);
        } else {
          setAssigneeOptions([]);
        }
      } catch (error) {
        console.error("Error fetching assignees:", error);
        setAssigneeOptions([]);
      } finally {
        setAssigneeLoading(false);
      }
    }, 300); // 300ms debounce
  };

  // Fetch currently assigned user when editing existing task
  const fetchCurrentAssignedUser = async (assignedToId: number) => {
    try {
      // First check if user is cached from task summary
      const cachedName = assigneeFromTaskSummary.current.get(assignedToId);
      if (cachedName) {
        const option = { label: cachedName, value: assignedToId };
        assigneeCache.current.set(assignedToId.toString(), [option]);
        setAssigneeOptions([option]);
        return;
      }

      // Check if user already loaded in formOptions
      if (formOptions?.Assignee && formOptions.Assignee.length > 0) {
        const foundUser = formOptions.Assignee.find(
          (opt: any) => opt.value === assignedToId,
        );
        if (foundUser) {
          assigneeCache.current.set(assignedToId.toString(), [foundUser]);
          setAssigneeOptions([foundUser]);
          return;
        }
      }

      // If not found anywhere, keep dropdown empty
      // User can search by typing the name to find them
      setAssigneeOptions([]);
    } catch (error) {
      console.error("Error fetching assigned user:", error);
      setAssigneeOptions([]);
    }
  };

  useEffect(() => {
    const getStatusOptions = async () => {
      const res = await API.post(getTaskOwnerStatus, {});
      console.log("status options response", res);
      if (res?.data?.data?.length > 0) {
        const statusOptions = res?.data?.data?.map((item: any) => ({
          label: item?.label,
          value: item?.value,
        }));
        setFormOptions((prev: any) => ({ ...prev, Status: statusOptions }));
      }
    };

    const getRDManagerStatusOptions = async () => {
      const res = await API.post(getTaskRDManagerStatus, {});
      // console.log('R&D manager status options response', res);
      if (res?.data?.data?.length > 0) {
        const rdManagerStatusOptions = res?.data?.data?.map((item: any) => ({
          label: item?.name,
          value: item?.Id,
        }));

        setFormOptions((prev: any) => ({
          ...prev,
          RDManagerStatus: rdManagerStatusOptions,
        }));
      }
    };

    // Load status options on mount (assignee options will be loaded on search)
    getStatusOptions();
    getRDManagerStatusOptions();
  }, []);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (assigneeSearchTimeout.current) {
        clearTimeout(assigneeSearchTimeout.current);
      }
    };
  }, []);

  const fetchTaskSummaryDetails = async () => {
    const res = await API.post(getTaskSummaryDetails, {
      RequestId: location?.state?.RId,
      CreatedBy: commonContextParams?.userId,
      RoleId: commonContextParams?.roleId,
    });
    // console.log('Task summary details response', res);
    if (res?.data?.data?.length > 0) {
      // Cache assignees from task summary for use in table and dropdown
      res.data.data.forEach((item: any) => {
        if (item?.assignedToId && item?.name) {
          assigneeFromTaskSummary.current.set(item.assignedToId, item.name);
          // Also populate assignee dropdown options for quick access
          const option = { label: item.name, value: item.assignedToId };
          assigneeCache.current.set(item.assignedToId.toString(), [option]);
        }
      });

      const formattedData = res?.data?.data?.map((item: any) => ({
        ...item,
        key: item?.taskDetailId,
      }));

      setTaskDetailsData(formattedData);
      return formattedData;
    }
  };

  const fetchRequestDetailsById = async (id: any) => {
    const res = await API.post(getRequestDetailsById, { RequestId: id });
    console.log("Request details by id response", res);
    if (res?.data?.data?.length > 0) {
      setRequestStatus(res?.data?.data[0]?.requestStatusId);
      let closureDate = dayjs(res?.data?.data[0]?.requestClosureDate);
      console.log(
        "closure date=>",
        closureDate,
        "request status=>",
        res?.data?.data[0]?.requestStatusId,
        "current rnd manager status=>",
        currentRDManagerStatus,
      );
      setClosureDate(closureDate.format("YYYY-MM-DD"));
      return res?.data?.data[0];
    }
  };

  useEffect(() => {
    (async () => {
      if (location?.state?.RId && location?.state?.RId > 0) {
        const data = await fetchTaskSummaryDetails();
        const res = await fetchRequestDetailsById(location?.state?.RId);

        if (
          location?.state?.TaskDetailId &&
          location?.state?.TaskDetailId > 0
        ) {
          console.log(
            "location?.state?.TaskDetailId =>",
            location?.state?.TaskDetailId,
            " data=>",
            data,
          );
          const obj = data?.find(
            (e: any) => e.taskDetailId == location?.state?.TaskDetailId,
          );
          console.log("objjj=>", obj.statusId, "res=>", res);
          if (location?.state.IsTaskDashboard == true) {
            setIsEditing(true);
            setSelectedStatusId(obj?.statusId);
          } else {
            setIsEditing(false);
          }

          setEditingKey(obj.key);
          setTaskCurrentStatus(obj?.statusId);
          setIsCurrentTaskExtended(obj?.isExtended);
          setCurrentRDManagerStatus(obj?.rdManagerStatusId);

          // Fetch the currently assigned user to show in the dropdown
          if (obj.assignedToId) {
            fetchCurrentAssignedUser(obj.assignedToId);
          }

          form.setFieldsValue({
            taskTitle: obj.taskTitle,
            taskDescription: obj.taskDescription,
            assignedToId: obj.assignedToId,
            taskDeadline: obj.taskDeadline ? dayjs(obj.taskDeadline) : null,
            statusId: obj.statusId,
            remarks: obj.remarks,
            rDManagerStatus: obj?.rdManagerStatusId,
            taskClosureRemarks: obj?.rdManagerClosureRemarks,
            hoursSpent: obj?.hoursSpent,
          });

          // OWNER ATTACHMENTS BIND
          if (obj?.taskOwnerAttachments) {
            const parsedOwner = JSON.parse(obj?.taskOwnerAttachments);

            const owner = parsedOwner.map((file: any) => ({
              uid: file.id.toString(),
              name: file.name,
              status: "done",
              url: file.path,
              id: file.id,
            }));

            setOwnerFiles(owner);
          }

          // CLOSURE ATTACHMENTS BIND
          // if (obj?.taskClosureAttachments) {
          //   const parsedClosure = JSON.parse(obj?.taskClosureAttachments);

          //   const closure = parsedClosure.map((file: any) => ({
          //     uid: file.id.toString(),
          //     name: file.name,
          //     status: "done",
          //     url: file.path,
          //     id: file.id,
          //   }));

          //   setClosureFiles(closure);
          // }
        }
      }
    })();
  }, [location?.state?.RId]);

  const handleSubmit = async () => {
    await withLoader(async () => {
      if (taskDetailsData?.length > 0) {
        // const allFields = form.getFieldsValue();
        console.log("all fields=>", taskDetailsData);
        const req = {
          TaskSummaryList: taskDetailsData || [],
          CreatedBy: commonContextParams?.userId,
          RequestId: location.state ? location.state?.RId : 0,
          RoleId: commonContextParams?.roleId,
        };
        const res = await API.post(insertUpdateTaskDetails, req);
        console.log("result on submit =>", res);

        if (
          res?.data?.status !== ApiStatus.OK &&
          res?.data?.status !== ApiStatus.Success
        ) {
          message.error(
            //data?.errorCode === "DBVALIDATION" ? data.message : "Failed.",
            res.data?.errorCode === "DB_VALIDATION" ||
              res.data?.errorCode === "DBVALIDATION"
              ? res.data.message
              : "Failed.",
          );
        }

        if (res?.data?.message === "OK") {
          message.success("Tasks submitted successfully");
          //navigate(-1);
          if (
            Number(commonContextParams?.roleId) === Number(RoleEnum.TaskOwner)
          ) {
            navigate("/TaskDashboard");
          } else {
            navigate("/RequestDashboard");
          }
        }
      } else {
        console.log("inside else ");
        message.error("Assign at least one task!");
      }
    });
  };

  const validateUpload = (
    file: File,
    currentFiles: UploadFile[],
  ): boolean | typeof Upload.LIST_IGNORE => {
    setUploadError(null);

    // ✅ FILE TYPE VALIDATION
    const extension = file?.name?.split(".").pop()?.toLowerCase();

    if (!extension || !allowedExtensions.includes(extension)) {
      setUploadError("Only PDF, DOC, DOCX, XLSX, CSV files are allowed.");
      return Upload.LIST_IGNORE;
    }

    // ✅ MAX FILE COUNT
    if (currentFiles.length >= 5) {
      setUploadError("Maximum 5 files allowed.");
      return Upload.LIST_IGNORE;
    }

    // ✅ SINGLE FILE SIZE
    const isValidSize = file.size / 1024 / 1024 <= 5;
    if (!isValidSize) {
      setUploadError(`${file.name} must be smaller than 5MB.`);
      return Upload.LIST_IGNORE;
    }

    // ✅ TOTAL FILE SIZE
    const totalSize =
      currentFiles.reduce((acc, f) => acc + (f.size || 0), 0) + file.size;

    if (totalSize / 1024 / 1024 > 30) {
      setUploadError("Total file size cannot exceed 30MB.");
      return Upload.LIST_IGNORE;
    }

    return false; // stop auto upload
  };

  const handleOwnerRemove = (file: any) => {
    if (file?.id) {
      setDeletedOwnerAttachmentIds((prev) =>
        prev ? `${prev},${file.id}` : `${file.id}`,
      );
    }

    setOwnerFiles((prev) => prev.filter((f) => f.uid !== file.uid));
  };

  const goToNextTab = () => {
    interfaceActionHandler?.NextTab?.();
  };

  const goToPrevTab = () => {
    interfaceActionHandler?.PrevTab?.();
  };

  return (
    <>
      {loading && <Loader />}
      <Col lg={24}>
        <Form
          form={form}
          layout="vertical"
          validateTrigger="onChange"
          initialValues={{ active: true }}
          //disabled={disableForm}
        >
          <Row gutter={[16, 16]} key={"newform"}>
            {canShowForm ? (
              <>
                <Col lg={6} xs={24} sm={24} md={12}>
                  <Form.Item
                    name="taskTitle"
                    label="Task Title"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a task title",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Task Title"
                      disabled={
                        RequestStatusEnum.TaskAssignmentPending ==
                          requestStatus &&
                        (commonContextParams?.roleId == RoleEnum.RnDManager ||
                          commonContextParams?.roleId == RoleEnum.RnDHead)
                          ? false
                          : true
                      }
                      maxLength={100}
                    />
                  </Form.Item>
                </Col>

                <Col lg={6} xs={24} sm={24} md={12}>
                  <Form.Item
                    name="taskDescription"
                    label="Task Description"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a task description",
                      },
                    ]}
                  >
                    <Input.TextArea
                      placeholder="Enter Task Description"
                      disabled={
                        RequestStatusEnum.TaskAssignmentPending ==
                          requestStatus &&
                        (commonContextParams?.roleId == RoleEnum.RnDManager ||
                          commonContextParams?.roleId == RoleEnum.RnDHead)
                          ? false
                          : true
                      }
                      rows={4}
                      maxLength={1000}
                      showCount
                    />
                  </Form.Item>
                </Col>

                <Col lg={6} xs={24} sm={24} md={12}>
                  <Form.Item
                    name="assignedToId"
                    label="Assigned To"
                    rules={[
                      { required: true, message: "Please select an assignee" },
                    ]}
                  >
                    <Select
                      placeholder="Type at least 2 characters to search"
                      options={assigneeOptions}
                      allowClear
                      showSearch
                      filterOption={false}
                      onSearch={handleAssigneeSearch}
                      notFoundContent={
                        assigneeLoading ? (
                          <div style={{ textAlign: "center", padding: "10px" }}>
                            <Spin size="small" />
                          </div>
                        ) : assigneeOptions.length === 0 &&
                          assigneeOptions.length === 0 ? (
                          "Type at least 2 characters to search"
                        ) : (
                          "No users found"
                        )
                      }
                      optionFilterProp="label"
                      disabled={
                        // RequestStatusEnum.TaskAssignmentPending == location?.state?.RequestStatus &&
                        taskCurrentStatus != TaskStatusEnum.Closed &&
                        (commonContextParams?.roleId == RoleEnum.RnDManager ||
                          commonContextParams?.roleId == RoleEnum.RnDHead)
                          ? false
                          : true
                      }
                    />
                  </Form.Item>
                </Col>

                <Col lg={6} xs={24} sm={24} md={12}>
                  <Form.Item
                    name="taskDeadline"
                    label="Task Deadline"
                    rules={[
                      { required: true, message: "Task deadline is required!" },
                      {
                          validator: (_, value) => {
                          if (!value || !closureDate) {
                          return Promise.resolve();
                          }

                          const selectedDate = dayjs(value);
                          const requestClosureDate = dayjs(closureDate);

                                  if (selectedDate.isAfter(requestClosureDate, "day")) {
                                    return Promise.reject(
                                      new Error(
                                        "Selecting a task deadline beyond request closure date is not allowed."
                                      )
                                    );
                                  }

                                  return Promise.resolve();
                                },
                              },
                    ]}
                  >
                    <FormDatePicker
                      name="taskDeadline"
                      label=""
                      placeholder="Select Task Deadline"
                      format="DD-MM-YYYY"
                      disabled={
                        (commonContextParams?.roleId == RoleEnum.RnDManager ||
                          commonContextParams?.roleId == RoleEnum.RnDHead) &&
                        (isCurrentTaskExtended == false ||
                          isCurrentTaskExtended == null) &&
                        taskCurrentStatus != TaskStatusEnum.Closed
                          ? false
                          : true
                      }
                      // disabledDate={(current: any) => {
                      //   return current && current.isBefore(dayjs(), "day");
                      // }}
                    />
                  </Form.Item>
                </Col>

                {requestStatus == RequestStatusEnum.TasksWIPWithTaskOwner ||
                requestStatus ==
                  RequestStatusEnum.PendingForRequestClosureRnDManager ||
                requestStatus ==
                  RequestStatusEnum.PendingForRequestClosureRnDHead ||
                requestStatus == RequestStatusEnum.RequestClosed ? (
                  <>
                    <Col lg={6} xs={24} sm={24} md={12}>
                      <Form.Item
                        name="statusId"
                        label="Status"
                        rules={[
                          { required: true, message: "Please select a status" },
                        ]}
                      >
                        <Select
                          placeholder="Select Status"
                          options={formOptions?.Status || []}
                          allowClear
                          disabled={
                            TaskStatusEnum.Closed == taskCurrentStatus
                              ? true
                              : RoleEnum.TaskOwner !=
                                  commonContextParams?.roleId
                                ? true
                                : false
                          }
                          onChange={(value) => {
                            setSelectedStatusId(value);
                            form.validateFields();
                          }}
                          maxTagCount="responsive"
                        />
                      </Form.Item>
                    </Col>
                    {selectedStatusId === TaskStatusEnum.Closed && (
                      <Col lg={6} xs={24} sm={24} md={12}>
                        <Form.Item
                          name="hoursSpent"
                          label="Hours Spent"
                          rules={[
                            {
                              required: true,
                              message: "Please enter hours spent",
                            },
                            {
                              pattern: /^[0-9]{1,4}(\.[0-9]{1,2})?$/,
                              message:
                                "Please enter max 4 digits with up to 2 decimals",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Enter hours spent"
                            disabled={
                              TaskStatusEnum.Closed == taskCurrentStatus
                                ? true
                                : RoleEnum.TaskOwner ==
                                    commonContextParams?.roleId
                                  ? false
                                  : true
                            }
                            maxLength={7}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    <Col lg={6} xs={24} sm={24} md={12}>
                      <Form.Item
                        name="remarks"
                        label="Remarks"
                        rules={[
                          {
                            required: true,
                            message: "Please enter remarks",
                          },
                        ]}
                      >
                        <Input.TextArea
                          placeholder="Enter Remarks"
                          disabled={
                            TaskStatusEnum.Closed == taskCurrentStatus
                              ? true
                              : RoleEnum.TaskOwner !=
                                  commonContextParams?.roleId
                                ? true
                                : false
                          }
                          rows={4}
                          maxLength={1000}
                          showCount
                        />
                      </Form.Item>
                    </Col>

                    <Col lg={6} xs={24} sm={24} md={12}>
                      <Form.Item
                        label="Attachments"
                        name="ownerAttachments"
                        validateStatus={uploadError ? "error" : ""}
                        help={uploadError}
                      >
                        <Upload
                          multiple
                          maxCount={5}
                          fileList={ownerFiles}
                          beforeUpload={(file) =>
                            validateUpload(file, ownerFiles)
                          }
                          onChange={({ fileList }) => {
                            setOwnerFiles(fileList.slice(0, 5));
                          }}
                          onRemove={handleOwnerRemove}
                          accept=".doc,.docx,.pdf,.xlsx,.xls,.msg,.eml,.ppt,.pptx,.png,.jpg,.jpeg,.zip"
                          disabled={
                            TaskStatusEnum.Closed == taskCurrentStatus
                              ? true
                              : RoleEnum.TaskOwner !=
                                  commonContextParams?.roleId
                                ? true
                                : false
                          }
                        >
                          <Button icon={<UploadOutlined />}>
                            Upload Files
                          </Button>
                        </Upload>

                        {/* {uploadError && (
                      <div
                        style={{ fontSize: 12, color: "#df1e1e", marginTop: 4 }}
                      >
                        {uploadError}
                      </div>
                    )} */}
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  <></>
                )}

                {taskCurrentStatus == TaskStatusEnum.Closed &&
                commonContextParams?.roleId != RoleEnum?.TaskOwner ? (
                  <>
                    <Col lg={6} xs={24} sm={24} md={12}>
                      <Form.Item
                        name="rDManagerStatus"
                        label="Central R&D Manager Status"
                        rules={[
                          { required: true, message: "Please select a status" },
                        ]}
                      >
                        <Select
                          placeholder="Select Status"
                          options={formOptions?.RDManagerStatus || []}
                          allowClear
                          disabled={
                            (commonContextParams?.roleId !=
                              RoleEnum.RnDManager &&
                              commonContextParams?.roleId !=
                                RoleEnum.RnDHead) ||
                            currentRDManagerStatus == TaskStatusEnum.Closed
                              ? true
                              : false
                          }
                          // mode="multiple"
                          maxTagCount="responsive"
                        />
                      </Form.Item>
                    </Col>

                    <Col lg={6} xs={24} sm={24} md={12}>
                      <Form.Item
                        name="taskClosureRemarks"
                        label="Task Closure Remarks(Central R&D Manager)"
                        rules={[
                          {
                            required: true,
                            message: "Please enter remarks",
                          },
                        ]}
                      >
                        <Input.TextArea
                          placeholder="Enter Remarks"
                          disabled={
                            (commonContextParams?.roleId !=
                              RoleEnum.RnDManager &&
                              commonContextParams?.roleId !=
                                RoleEnum.RnDHead) ||
                            currentRDManagerStatus == TaskStatusEnum.Closed
                              ? true
                              : false
                          }
                          rows={4}
                          maxLength={1000}
                          showCount
                        />
                      </Form.Item>
                    </Col>

                    {}
                  </>
                ) : (
                  <></>
                )}

                <Col lg={24} xs={24} sm={24} md={12}>
                  <div className="text-end">
                    {requestStatus ==
                    RequestStatusEnum.TasksWIPWithTaskOwner ? (
                      <Button
                        className="btn-submit"
                        onClick={() => handleUpdate()}
                        disabled={
                          taskCurrentStatus == TaskStatusEnum.Closed &&
                          commonContextParams?.roleId == RoleEnum.TaskOwner
                            ? true
                            : currentRDManagerStatus == TaskStatusEnum.Closed
                              ? true
                              : // : currentRDManagerStatus != TaskStatusEnum.Closed &&
                                //     commonContextParams?.roleId !=
                                //       RoleEnum.RnDManager &&
                                //     commonContextParams?.roleId != RoleEnum.RnDHead
                                //   ? true
                                false
                        }
                      >
                        Update
                      </Button>
                    ) : (
                      <Button
                        className="btn-submit"
                        onClick={() => handleAdd()}
                        disabled={
                          requestStatus ==
                            RequestStatusEnum.TasksWIPWithTaskOwner ||
                          requestStatus ==
                            RequestStatusEnum.PendingForRequestClosureRnDManager ||
                          requestStatus ==
                            RequestStatusEnum.PendingForRequestClosureRnDHead ||
                          requestStatus == RequestStatusEnum.RequestClosed
                            ? true
                            : false
                        }
                      >
                        Add
                      </Button>
                    )}
                  </div>
                </Col>
              </>
            ) : (
              <></>
            )}

            <Col lg={24} xs={24} sm={24} md={24}>
              {taskDetailsData && taskDetailsData?.length > 0 ? (
                <>
                  <Table
                    columns={columns}
                    dataSource={taskDetailsData}
                    pagination={false}
                  />
                </>
              ) : (
                <></>
              )}
            </Col>
          </Row>

          <div className="row">
            <div className="d-flex justify-content-end gap-2">
              <Button
                className=""
                onClick={() => {
                  goToPrevTab();
                }}
              >
                {"<"}
              </Button>

              <Button
                className=""
                onClick={() => {
                  goToNextTab();
                }}
              >
                {">"}
              </Button>

              {requestStatus == RequestStatusEnum.TaskAssignmentPending ? (
                <>
                  <Button className="btn-submit" onClick={() => handleSubmit()}>
                    Submit
                  </Button>
                </>
              ) : (
                <></>
              )}
              <Button
                className="btn-reset"
                onClick={() => {
                  // navigate(-1);
                  if (
                    Number(commonContextParams?.roleId) ===
                    Number(RoleEnum.TaskOwner)
                  ) {
                    navigate("/TaskDashboard");
                  } else {
                    navigate("/RequestDashboard");
                  }
                }}
              >
                Back
              </Button>
            </div>
          </div>

          <Modal
            title="Task History"
            open={isHistoryIconClicked}
            onOk={handleHistoryClose}
            onCancel={handleHistoryClose}
            footer={null}
            width={800}
            destroyOnClose
          >
            <Table
              columns={Historycolumns}
              dataSource={historyData || []}
              pagination={false}
              rowKey="id"
            />
          </Modal>
        </Form>
      </Col>
    </>
  );
};

export default TaskDetailsTab;
